import React, {useCallback, useState, useEffect} from 'react'
import app from './App.module.scss'
import Main from '../../pages/Main/Main'
import Header  from '../Header/Header'
import Footer  from '../Footer/Footer'
import { ModalImage } from '../ModalImage/ModalImage'
import { MenuMobile } from '../MenuMobile/MenuMobile'
import ButtonCommunication from '../ButtonCommunication/ButtonCommunication'


import UpButton from '../UpButton/UpButton'

function App() {

  const [isPopupImageOpen, setIsPopupImageOpen] = useState(false)
  const [isMenuMobile, setIsMenuMobile] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  const vh = window.innerHeight / 100;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  /*useEffect(() => {

    setTimeout(function() {
      setIsPopupOpen(true);
    }, 10000);
  }, []);*/

  const handleCloseMenuMobile = useCallback(() => {
    setIsMenuMobile(false)
  }, []);

  const handleOpenMenuMobile = useCallback(() => {
    setIsMenuMobile(true)
  }, []);

  const handleImageClose = useCallback(() => {
    setIsPopupImageOpen(false)
  }, []);

  const handleImageOpen = useCallback(() => {
      setIsPopupImageOpen(true)
  }, [])

  const handleOpen = useCallback(() => {
    setIsPopupOpen(true)
  }, []);

  const handleClose = useCallback(() => {
    setIsPopupOpen(false)
  }, []);



  return (
    <div className={app.page}>
      <Header
        isOpen={handleOpenMenuMobile}
      />
      <Main
        isImageOpen={handleImageOpen}
        popupOpen={handleOpen}
      />
      <Footer/>
      <UpButton/>
      <ButtonCommunication/>
      {isMenuMobile && <MenuMobile
        onClose={handleCloseMenuMobile}
      />}
      {isPopupImageOpen && 
      <ModalImage
        onClose={handleImageClose}
      />}
    </div>
  );
}

export default App;
